// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"200":"80a6a381","503":"21b08ac0"}[chunkId] + ".chunk.css");